import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

/**
 * Stats rule for recording Deuce attempts (Indoor Football).
 * Records attempted and completed deuce kicks.
 */
export default class DeuceStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            FootballState.Deuce === fragment.associatedState &&
            (play.historyContains(FootballState.DeuceGood) ||
                play.historyContains(FootballState.DeuceMissed)) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const deuceGoodFragment = play.getFirstFragment(
            FootballState.DeuceGood
        );
        const { kickedBy, id } =
            play.getFirstFragment(FootballState.Kick) || {};

        const stats = [];

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: kickedBy?.teamId,
                playerId: kickedBy?.id,
                driveId: gameContext.currentDriveId,
                fragmentId: id,
                category: FootballStatsCategory.DEUCE,
                values: {
                    completed: deuceGoodFragment ? 1 : 0,
                    attempted: 1
                }
            },
            stats
        );

        return stats;
    }
}
